import type { Severity, Status } from '@/models/issue';

const SEV_COLOR: Record<Severity, { bg: string; fg: string }> = {
  critical: { bg: 'var(--color-error-bg)', fg: 'var(--color-error)' },
  major: { bg: 'var(--color-warning-bg)', fg: 'var(--color-warning)' },
  minor: { bg: 'rgba(217, 119, 6, 0.04)', fg: 'var(--color-warning)' },
  cosmetic: { bg: 'var(--color-info-bg)', fg: 'var(--color-info)' },
};

const STATUS_COLOR: Record<Status, { bg: string; fg: string; pulse?: boolean }> = {
  open: { bg: 'var(--color-info-bg)', fg: 'var(--color-info)', pulse: true },
  in_progress: { bg: 'var(--color-warning-bg)', fg: 'var(--color-warning)', pulse: true },
  fixed: { bg: 'var(--color-success-bg)', fg: 'var(--color-success)' },
  deferred: { bg: '#F8F8F8', fg: 'var(--text-muted)' },
  closed: { bg: '#F8F8F8', fg: 'var(--text-muted)' },
  duplicate: { bg: '#F8F8F8', fg: 'var(--text-muted)' },
  wontfix: { bg: '#F8F8F8', fg: 'var(--text-muted)' },
};

function Pill({ bg, fg, pulse, label }: { bg: string; fg: string; pulse?: boolean; label: string }) {
  return (
    <span
      className="inline-flex items-center gap-1.5 px-2 py-0.5 text-[11px] font-medium uppercase tracking-wider"
      style={{ background: bg, color: fg, borderRadius: 0 }}
    >
      {pulse && (
        <span
          className="w-1.5 h-1.5 rounded-full"
          style={{ background: fg, animation: 'pulse 2s ease-in-out infinite' }}
        />
      )}
      {label}
    </span>
  );
}

export function SeverityBadge({ severity }: { severity: Severity }) {
  const c = SEV_COLOR[severity];
  return <Pill bg={c.bg} fg={c.fg} label={severity} />;
}

export function StatusBadge({ status }: { status: Status }) {
  const c = STATUS_COLOR[status];
  return <Pill bg={c.bg} fg={c.fg} pulse={c.pulse} label={status.replace('_', ' ')} />;
}

export function Tag({ children }: { children: string }) {
  return (
    <span
      className="inline-block px-2 py-0.5 text-[11px] font-mono"
      style={{
        background: 'transparent',
        color: 'var(--text-muted)',
        border: '1px solid var(--border)',
        borderRadius: 0,
      }}
    >
      {children}
    </span>
  );
}
